import { Platform } from 'react-native';

import { useFeatureFlag } from '@order/LaunchDarkly';

export const usePushNotificationPermissionPrimerEnabled = () => {
  const pushNotificationPrimerVariant = useFeatureFlag('CELS-5256-geofencing-primer-variant');

  const supportedVariants: (typeof pushNotificationPrimerVariant)[] = ['A', 'B'];
  const isSupportedVariant = supportedVariants.includes(pushNotificationPrimerVariant);

  return {
    canEnablePushNotificationPrimer: Platform.OS !== 'web' && isSupportedVariant,
    pushNotificationPrimerVariant,
  };
};
